export const langSwitch = () => {
    const langSwitchElms = document.querySelectorAll('.lang-switch');
    const dropdownElms = document.querySelectorAll('.lang-switch__dropdown');

    langSwitchElms.forEach(langSwitchElm => {
        const button = langSwitchElm.querySelector('.lang-switch__btn');
        const dropdown = langSwitchElm.querySelector('.lang-switch__dropdown');

        button.addEventListener('click', () => {
            dropdownElms.forEach(dropdownElm => {
                if (dropdownElm != dropdown) {
                    dropdownElm.classList.remove('lang-switch__dropdown--active');
                }
            });

            dropdown.classList.toggle('lang-switch__dropdown--active');
            dropdown.style.transition = 'all 0.3s ease-in-out';
        });
    });

    window.addEventListener("scroll", () => {
		dropdownElms.forEach(dropdownElm => {
            dropdownElm.classList.remove('lang-switch__dropdown--active');
        });
	});
};
